<script>
    import GenericFreeBets from "../lib/components/modals/freebets/GenericFreeBets.svelte";
    import { ICONS } from "../js/icons";
    import { IGP_ADAPTER } from "../lib/components/modals/freebets/providers/igp.js";
    const adapter = IGP_ADAPTER;
    const icons = ICONS;
</script>

<GenericFreeBets {adapter} {icons} />
